import React from "react";
import { Link } from "react-router-dom";

export default function NotFoundPage() {
    return (
        <div data-testid="not-found-page" className="min-h-[60vh] flex items-center justify-center px-4">
            <div className="text-center">
                <p className="text-xs uppercase tracking-[0.3em] text-brand-secondary font-bold mb-3">404</p>
                <h1 className="font-serif text-5xl sm:text-6xl text-brand-primary font-semibold leading-tight">This page took a wrong turn.</h1>
                <p className="mt-4 text-brand-textMuted">Let's get you back to solid ground.</p>
                <Link to="/" data-testid="404-home-link" className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-brand-primary text-white text-sm font-semibold hover:bg-brand-primaryHover transition-colors">
                    Back to home
                </Link>
            </div>
        </div>
    );
}
